import ImageSection from 'src/components/ui/GlobalComponents/ImageSection/ImageSection';
import { Challenge } from 'src/model/Challenge';
import { Word } from '../../../../model/Word';
import SpellingItem from '../Items/SpellingItem/SpellingItem';
import styles from './GivenBlankExampleConfirm.module.scss';

interface GivenBlankExampleConfirmProps {
    shuffledChoices: { isCorrect: boolean, text: string, wordId: number }[];
    onAnswer: (isCorrect: boolean) => void;
    correctWord: Word;
    challenge: Challenge;
}

const GivenBlankExampleConfirm = ({ shuffledChoices, onAnswer, correctWord, challenge }: GivenBlankExampleConfirmProps) => {

    return (
        <div className={styles.givenBlankExampleConfirm}>
            <ImageSection word={correctWord!}/>
            <div className={styles.quote}>❝</div>
            <div className={styles.definition}>
                {challenge.Question}
            </div>
            <div className={styles.spellingContainer}>
                {shuffledChoices.map((choice, index) => (
                    <SpellingItem
                        key={index}
                        text={choice.text}
                        isAnswer={choice.isCorrect}
                        index={index}
                        onAnswer={onAnswer}
                        correctWord={correctWord!}
                    />
                ))}
            </div>
        </div>
    );
};

export default GivenBlankExampleConfirm;